import { RootStore } from "./rootStore";
import { observable, action, runInAction, makeAutoObservable } from "mobx";
import agent from "../api/agent";
import { IList } from "../models/listOfValours";

export default class ListOfValoursStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  @observable idType: IList[] = [];
  @observable documentTypes: IList[] = [];
  @observable rejectionConcepts:IList[]=[];

  //lista ciudades
  @observable cities: IList[] = [];
  //lista departamentos
  @observable countrySubentities: IList[] = [];

  //lista regimen fiscal
  @observable taxLevelName: IList[] = [];
  //lista tributo
  @observable partyTax: IList[] = [];
  //lista responsabilidades fiscales
  @observable taxLevelCode: IList[] = [];

  @action getPartyTax = async () => {
    if (this.partyTax.length < 1) {
      try {
        const partyTax = await agent.ListOfValours.getPartyTax();
        runInAction(() => {
          for (var key in partyTax) {
            this.partyTax.push({
              key: `${key}-partytax}`,
              text: `${key}-${partyTax[key]}`,
              value: key,
            });
          }
        });
      } catch (error) {
        console.error(
          "UPS! No se pudo cargar la lista responsabilidades fiscales"
        );
      }
    }
  };

  @action getTaxLevelName = async () => {
    if (this.taxLevelName.length < 1) {
      try {
        const taxLevelName = await agent.ListOfValours.getTaxLevelName();
        runInAction(() => {
          for (var key in taxLevelName) {
            this.taxLevelName.push({
              key: `${key}-taxlevel}`,
              text: `${key}-${taxLevelName[key]}`,
              value: key,
            });
          }
        });
      } catch (error) {
        console.error("UPS! No se pudo cargar la lista taxlevel");
      }
    }
  };

  @action getDocumentTypes = async () => {
    if (this.documentTypes.length < 1) {
      try {
        const documentTypes = await agent.ListOfValours.getDocumentTypes();
        runInAction(() => {
          for (var key in documentTypes) {
            this.documentTypes.push({
              key: `${key}-documentTypes}`,
              text: `${key}-${documentTypes[key]}`,
              value: key,
            });
          }
        });
      } catch (error) {
        console.error("UPS! No se pudo cargar la lista taxlevel");
      }
    }
  };

  @action getCountrySubentities = async () => {
    try {
      const countrySub = await agent.ListOfValours.getCountrySubentities();
      runInAction(() => {
        this.countrySubentities = [];
        for (var key in countrySub) {
          this.countrySubentities.push({
            key: `${key}-countrysubentities}`,
            text: `${countrySub[key]}`,
            value: key,
          });
        }
      });
    } catch (error) {
      console.error("UPS! No se pudo cargar la lista departamentos");
    }
  };

  @action getIdType = async () => {
    if (this.idType.length < 1) {
      try {
        const ids = await agent.ListOfValours.getIdType();
        runInAction(() => {
          for (var key in ids) {
            this.idType.push({
              key: `${key}-idtype}`,
              text: ids[key],
              value: key,
            });
          }
        });
      } catch (error) {
        console.error("UPS! No se pudo cargar la lista idType");
      }
    }
  };

  @action getCities = async (stateCode: string) => {
    try {
      const cities = await agent.ListOfValours.getCities(stateCode);
      runInAction(() => {
        this.cities = [];
        for (var key in cities) {
          this.cities.push({
            key: `${key}-cities}`,
            text: `${cities[key]}`,
            value: key,
          });
        }
      });
    } catch (error) {
      console.error("UPS! No se pudo cargar la lista cities");
    }
  };

  @action getTaxLevelCode = async () => {
    if (this.taxLevelCode.length < 1) {
      try {
        const taxLevelCode = await agent.ListOfValours.getTaxLevelCode();
        runInAction(() => {
          for (var key in taxLevelCode) {
            this.taxLevelCode.push({
              key: `${key}-taxlevelcode}`,
              text: `${key}-${taxLevelCode[key]}`,
              value: key,
            });
          }
        });
      } catch (error) {
        console.error("UPS! No se pudo cargar la lista taxType");
      }
    }
  };

  @action getRejectionConcepts = async () => {
    if (this.rejectionConcepts.length < 1) {
      try {
        const rejectionConcepts = await agent.ListOfValours.getRejectionConcepts();
        runInAction(() => {
          for (var key in rejectionConcepts) {
            this.rejectionConcepts.push({
              key: `${key}-rejectionConcepts}`,
              text: `${rejectionConcepts[key]}`,
              value: key,
            });
          }
        });
      } catch (error) {
        console.error("UPS! No se pudo cargar la lista rejectionConcepts");
      }
    }
  };

  @action getRejectionConceptsByEmail = async (token:string) => {
    if (this.rejectionConcepts.length < 1) {
      try {
        const rejectionConcepts = await agent.ListOfValours.getRejectionConceptsByEmail(token);
        runInAction(() => {
          for (var key in rejectionConcepts.data) {
            this.rejectionConcepts.push({
              key: `${key}-rejectionConcepts}`,
              text: `${rejectionConcepts.data[key]}`,
              value: key,
            });
          }
        });
      } catch (error) {
        console.error("UPS! No se pudo cargar la lista rejectionConcepts");
      }
    }
  };
}
